"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.intro.start': 'Start Onboarding',
    'onboarding.intro.optimize': 'Optimize Operations and Processes',
    'onboarding.intro.moment': 'The time has come for the strategic implementation of advanced AI Assistants.',
    'onboarding.intro.enables': 'Using them in the company enables:',
};
